module.exports = __webpack_public_path__ + "img/icon_coupon_used.b6d3739a.png";